import { Card, CardContent, Stack, SvgIcon, Typography } from '@mui/material';

import { ReactComponent as Document } from 'assets/images/ic_document.svg';

const NoAuditCard = (): React.ReactElement => (
  <Card variant="outlined">
    <CardContent>
      <SvgIcon
        component={Document}
        inheritViewBox
        className="view-icon"
        fontSize="inherit"
        htmlColor="#3D3C42"
      />
      <Stack
        direction="column"
        spacing={4}
        justifyContent="center"
        alignItems="center"
      >
        <Typography variant="h6">No audit entries found.</Typography>
      </Stack>
    </CardContent>
  </Card>
);

export default NoAuditCard;
